// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__iDZTj","colMaxWidth":"Table_colMaxWidth__1FJTg"};